// Czas zadania w tle liczony ZEGAREM SERWERA (karta PORADA-TLE-2, 31.10.2026).
//
// Zdarzenie 30.10 22:39: porada pogłębiona trwała na serwerze 20,5 min (`started_at` → `finished_at`), a interfejs pokazał
// „111 minut”. Przyczyna: UI mierzył czas zegarem przeglądarki — od chwili odpowiedzi 202 do chwili, w której PRZEGLĄDARKA
// zauważyła koniec (`koniec = Date.now()` przy odczycie `done`). Gdy karta spała / była w tle / odpytywanie wisiało na
// błędach bramy (które celowo ignorujemy), zauważenie końca opóźniało się o dziesiątki minut i cały ten czas wpadał do
// „czasu zadania” (a przez medianę także do „typowo N min”).
//
// Zasada: gdy serwer podał `started_at` (i `finished_at`), czas zadania = to, co policzył serwer. Dla zadania trwającego
// bierzemy zegar serwera (`czas_serwera` z odpowiedzi statusu) i przesunięcie względem zegara przeglądarki zmierzone w chwili
// odczytu — dzięki temu rozjazd zegarów komputera i serwera nie psuje licznika. Czysty JS, bez Reacta; wszystko przyjmuje `teraz`.

/** ISO z serwera → ms (UTC) albo null. Napis bez oznaczenia strefy (naiwny datetime z Mongo) traktujemy jako UTC, nie lokalny. */
export function parsujUtc(iso) {
  if (typeof iso !== "string" || !iso.trim()) return null;
  const t = iso.trim();
  const maStrefe = /(Z|[+-]\d{2}:?\d{2})$/i.test(t);
  const gotowy = maStrefe ? t : `${t.replace(" ", "T")}Z`;
  const ms = Date.parse(gotowy);
  return Number.isFinite(ms) ? ms : null;
}

/**
 * Z odpowiedzi `GET /advice/jobs/{id}` (`started_at`, `created_at`, `finished_at`, `czas_serwera`) → znaczniki serwera:
 * `{ startMs, koniecMs, przesuniecieMs }` (pola nieznane = null). `przesuniecieMs` = zegar serwera − zegar przeglądarki w
 * chwili odczytu `teraz`. `startMs` z `started_at` (praca), a gdy go brak — z `created_at` (zadanie czekało w kolejce).
 */
export function znacznikiSerwera(d, teraz = Date.now()) {
  if (!d || typeof d !== "object") return { startMs: null, koniecMs: null, przesuniecieMs: null };
  const serwerTeraz = parsujUtc(d.czas_serwera);
  return {
    startMs: parsujUtc(d.started_at) ?? parsujUtc(d.created_at),
    koniecMs: parsujUtc(d.finished_at),
    przesuniecieMs: serwerTeraz === null ? null : serwerTeraz - teraz,
  };
}

/**
 * Czas zadania w ms z `{ startMs, koniecMs, przesuniecieMs }` (znaczniki serwera) w chwili `teraz` (zegar przeglądarki):
 *  - koniec znany → `koniecMs − startMs` (nie zależy od tego, kiedy przeglądarka zauważyła koniec),
 *  - trwa → `teraz + przesuniecieMs − startMs` (bez przesunięcia: zakładamy zgodne zegary).
 * Brak `startMs` → null (wołający wraca do zegara przeglądarki). Wynik nigdy ujemny.
 */
export function czasZadaniaMs(zn, teraz = Date.now()) {
  if (!zn || !Number.isFinite(zn.startMs)) return null;
  if (Number.isFinite(zn.koniecMs)) return Math.max(0, zn.koniecMs - zn.startMs);
  const przesuniecie = Number.isFinite(zn.przesuniecieMs) ? zn.przesuniecieMs : 0;
  return Math.max(0, teraz + przesuniecie - zn.startMs);
}
